import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { pageFactory } from "../modules/factory";
export class vnAppZoneMenuSidebar extends vnAppZone {
    constructor(destination) {
        super(destination);
        this.zoneName = "MenuSidebar";
        this.isOnAlwaysReloadMode = true;
    }
    defineRoutes() {
        let factory = new pageFactory();
        let _mythis = this;
        this.addForRoute("all", function () {
            let moduleObj = factory.get_actionHandler("menu_sidebar", _mythis);
            _mythis.loadModule(moduleObj);
        }, null);
        this.addForRoute("/menu/sidebar", function () { }, null);
    }
}
